var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34878"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 54",
  d: "M0 0v11.3l1.837.686 15.115-5.648Z",
  fill: "#dadd4e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 55",
  d: "M0 12.669v11.332l17-6.352-15.163-5.665Z",
  fill: "#9dbe41"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 56",
  d: "m1.836 11.982 15.163 5.666v-11.3l-.049-.018Z",
  fill: "#31813b"
}))));
export default SvgLogoSmall;